// S12: /service/api/media needs the token now, and <a href> cannot send it. Clicks on media links are fetched with the
// token and opened from a blob. The blob is re-typed: a blob: URL runs in OUR origin and ignores the server's
// Content-Disposition/CSP, so html/svg/js must never open inline.
import handleInvalidToken from './invalidToken'

const PREFIX = '/service/api/media/'
// keep in sync with backend/utils/s12Media.js INLINE
const INLINE = { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', gif: 'image/gif', webp: 'image/webp', pdf: 'application/pdf' }

export async function openMedia(href, downloadName) {
    const u = new URL(href, window.location.href)
    let name = u.pathname.slice(PREFIX.length)
    try { name = decodeURIComponent(name) } catch (e) { }
    const mime = !downloadName && INLINE[(name.split('.').pop() || '').toLowerCase()]
    const win = mime ? window.open('', '_blank') : null // synchronous, so the popup blocker allows it
    try {
        const r = await fetch(u.pathname + u.search, { headers: { Authorization: localStorage.getItem('__token__') || '' } })
        if (r.status === 403 && handleInvalidToken(403, await r.clone().json().catch(() => null))) {
            if (win) win.close()
            return
        }
        if (!r.ok) {
            if (win) win.close()
            alert('De momento não foi possível abrir o documento. Tente novamente mais tarde.')
            return
        }
        const obj = URL.createObjectURL(new Blob([await r.arrayBuffer()], { type: mime || 'application/octet-stream' }))
        if (win) {
            win.location.href = obj
        } else {
            const a = document.createElement('a')
            a.href = obj
            a.download = downloadName || name
            document.body.appendChild(a)
            a.click()
            a.remove()
        }
        setTimeout(() => URL.revokeObjectURL(obj), 60000)
    } catch (e) {
        if (win) win.close()
        console.error(e)
    }
}

// one capture-phase listener covers every rendered <a href="/service/api/media/..."> (modals, consultar, comunicações...)
export function installMediaLinkHandler() {
    document.addEventListener('click', (e) => {
        if (e.defaultPrevented || e.button !== 0 || !localStorage.getItem('__token__')) return
        const a = e.target && e.target.closest && e.target.closest('a[href]')
        if (!a) return
        const u = new URL(a.href, window.location.href)
        if (u.origin !== window.location.origin || u.pathname.indexOf(PREFIX) !== 0 || u.searchParams.has('sig')) return
        e.preventDefault()
        openMedia(a.href, a.hasAttribute('download') ? (a.getAttribute('download') || undefined) : undefined)
    }, true)
}
